import * as yup from 'yup';
import { RecipeNutrient } from '@web/components';

export const component = RecipeNutrient;

export const schema = yup.object({
  label: yup.string().required(),
  value: yup.string().required(),
});
